var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightEmergencyOn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1754034775374,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2395,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M887.376 481.053a29.057 29.057 0 0 0-29.127 29.127c0 189.084-153.767 342.85-342.85 342.85s-342.85-153.767-342.85-342.85c0-16.142-12.986-29.127-29.127-29.127s-29.127 12.986-29.127 29.127c0 54.128 10.559 106.678 31.554 156.194 20.146 47.818 49.152 90.658 85.925 127.553 36.773 36.773 79.735 65.778 127.553 85.925 49.516 20.875 102.066 31.554 156.194 31.554 54.128 0 106.678-10.559 156.194-31.554 47.818-20.146 90.658-49.152 127.553-85.925 36.773-36.773 65.778-79.735 85.925-127.553 20.875-49.516 31.554-102.066 31.554-156.194-0.242-16.142-13.229-29.127-29.37-29.127z",
    "p-id": 2396,
    fill: "#37fc44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M331.898 349.131c7.404 0 14.928-2.791 20.631-8.496l130.222-130.222V693.68c0 16.142 12.986 29.127 29.127 29.127s29.127-12.986 29.127-29.127V210.413l130.222 130.222c5.703 5.703 13.107 8.496 20.631 8.496s14.928-2.791 20.631-8.496c11.408-11.408 11.408-29.855 0-41.142L532.75 119.633c-5.703-5.703-13.349-8.617-20.875-8.496-7.524 0-15.05 2.791-20.753 8.496l-179.739 179.86c-11.408 11.408-11.408 29.855 0 41.142 5.583 5.703 13.107 8.496 20.511 8.496z",
    "p-id": 2397,
    className: "custom-cursor-on-hover",
    fill: "#37fc44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightEmergencyOn);
export default __webpack_public_path__ + "static/media/light-emergency-on.7a79faf2f61688f1457c548f26f71ffb.svg";
export { ForwardRef as ReactComponent };